"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2035],{

/***/ 34489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ Layout; },
/* harmony export */   "Fe": function() { return /* binding */ Terms; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "gJ": function() { return /* binding */ BackGround; },
/* harmony export */   "zV": function() { return /* binding */ EmptySpace; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77366);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100vw;\n	min-height: 100%;\n	background-color: #000000;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: row;\n	min-height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	flex: 1 0 auto;\n	position: relative;\n	min-height: 100%;\n	max-width: 100%;\n	min-width: 60vw;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	background-color: white;\n	overflow-y: auto;\n	overflow-x: hidden;\n\n	@media screen and (max-device-height: 900px) {\n		justify-content: start;\n	}\n\n	.container {\n		margin: 20px auto;\n		width: 90vw;\n		max-width: 500px;\n		border-radius: 30px;\n		box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,\n			rgb(145 158 171 / 12%) 0px 12px 24px 10px;\n		padding: 5%;\n\n		.description1 {\n			font-style: normal;\n			font-weight: 400;\n			font-size: 15px;\n			line-height: 17px;\n			color: #111111;\n			text-align: center;\n		}\n\n		.description2 {\n			text-align: center;\n			font-weight: 400;\n			font-size: 15px;\n			line-height: 17px;\n			color: #111111;\n			white-space: pre-wrap;\n			word-break: break-all;\n		}\n\n		> .title {\n			font-size: 30px;\n			font-weight: 800;\n			text-align: left;\n			color: #111;\n			text-align: center;\n		}\n\n		> .inputLabel {\n			height: 20px;\n			align-self: stretch;\n			flex-grow: 0;\n			font-family: NanumGothic;\n			font-size: 14px;\n			font-weight: bold;\n			font-stretch: normal;\n			font-style: normal;\n			line-height: 1.43;\n			letter-spacing: 0.4px;\n			text-align: left;\n			color: #000;\n		}\n\n		> .textFiled {\n			height: 48px;\n			line-height: 48px;\n			align-self: stretch;\n			flex-grow: 0;\n			display: flex;\n			flex-direction: row;\n			justify-content: flex-start;\n			align-items: flex-start;\n			gap: 10px;\n			padding: 12px;\n			border-radius: 8px;\n			border: solid 1px #afb1b6;\n			background-color: white;\n			width: 100%;\n			margin-top: 8px;\n			box-shadow: rgb(145 158 171 / 20%) 0px 0px 2px 0px,\n				rgb(145 158 171 / 12%) 0px 12px 24px 10px;\n		}\n\n		.link {\n			font-weight: 700;\n			font-size: 12px;\n			line-height: 10px;\n			text-decoration-line: underline;\n			color: #afb1b6;\n		}\n\n		.goJoin {\n			font-weight: 700;\n			font-size: 16px;\n			line-height: 16px;\n			text-align: center;\n\n			/* Black */\n\n			color: #000000;\n			> span {\n				background: var(--primary);\n				text-decoration-line: underline;\n				-webkit-background-clip: text;\n				-webkit-text-fill-color: transparent;\n				background-clip: text;\n				text-fill-color: transparent;\n			}\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 0;\n	line-height: 1.5714285714285714;\n	font-size: 13px;\n	font-weight: 400;\n	text-align: center;\n	color: #212b36;\n	margin-top: 24px;\n\n	> a {\n		margin: 0;\n		color: #212b36;\n		&:hover {\n			color: #0378ef;\n		}\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: ",
        "px;\n	width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var BackGround = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject());
var Layout = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject1());
var Content = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject2());
var Terms = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject3());
var EmptySpace = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div */ .Z.div(_templateObject4(), function(props) {
    return props.space;
});


/***/ }),

/***/ 66660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$q": function() { return /* binding */ TitleComponentWithWhiteBlueLogo; },
/* harmony export */   "$t": function() { return /* binding */ TitleWrapper; },
/* harmony export */   "P": function() { return /* binding */ BottomWrapper; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "r3": function() { return /* binding */ TitleComponent; },
/* harmony export */   "t4": function() { return /* binding */ WrapperContainer; },
/* harmony export */   "vo": function() { return /* binding */ LightLine; },
/* harmony export */   "w$": function() { return /* binding */ SuperLightLine; },
/* harmony export */   "x1": function() { return /* binding */ Line; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	color: var(--card-bg);\n	margin-top: 40px;\n\n	max-width: 80%;\n	text-align: center;\n\n	.desc-no-padding {\n		padding-top: 15px;\n		font-size: 16px;\n		white-space: pre-wrap;\n		padding-right: 30px;\n\n		> a {\n			text-decoration: underline;\n		}\n	}\n\n	.bold {\n		font-weight: bold;\n	}\n\n	.title {\n		font-size: 24px;\n		font-weight: 800;\n	}\n\n	.sub-title {\n		font-size: 16px;\n		font-weight: 400;\n		white-space: pre-wrap;\n	}\n\n	.help {\n		font-size: 15px;\n		a {\n			text-decoration: underline;\n			color: var(--primary);\n		}\n	}\n\n	.btn {\n		border-radius: 30px;\n		border: 2px solid var(--primary);\n		background-color: transparent;\n		font-size: 20px;\n		font-weight: 700;\n		max-width: 450px;\n		width: 100%;\n		padding: 10px;\n\n		@media screen and (max-width: 768px) {\n			font-size: 16px;\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n	align-items: center;\n	justify-content: start;\n	position: relative;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	background-color: white;\n	border-radius: 30px;\n	padding: 40px 40px;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n\n	* {\n		white-space: pre-wrap;\n		word-break: break-all;\n		color: var(--card-bg);\n	}\n\n	@media screen and (max-width: 768px) {\n		padding: 30px;\n		width: 100%;\n		border-radius: 10px;\n	}\n\n	.detail-title {\n		color: var(--card-bg);\n		font-size: 27px;\n		font-weight: 800;\n		line-height: normal;\n		white-space: nowrap;\n	}\n\n	.center {\n		width: 100%;\n		text-align: center;\n	}\n\n	.channeltalk-link {\n		color: var(--primary);\n	}\n\n	.subheading {\n		font-size: 24px;\n		font-weight: bold;\n		white-space: pre-wrap;\n		padding-bottom: 10px;\n		position: relative;\n	}\n\n	.guide-link {\n		text-decoration: underline;\n	}\n\n	.desc {\n		font-size: 16px;\n		white-space: pre-wrap;\n		padding-top: 15px;\n\n		.linkify {\n			color: var(--primary);\n			cursor: pointer;\n		}\n\n		a {\n			text-decoration: underline;\n		}\n	}\n\n	.btn {\n		flex: 1;\n		font-size: 18px;\n		border-radius: 15px;\n		font-weight: bold;\n	}\n\n	.desc-no-padding {\n		padding-top: 15px;\n		font-size: 16px;\n		white-space: pre-wrap;\n		padding-right: 30px;\n\n		> a {\n			text-decoration: underline;\n		}\n	}\n\n	.comment-content-wrapper {\n		display: flex;\n		flex-direction: column;\n\n		.comment-box {\n			background-color: var(--bg-white);\n			padding: 10px;\n\n			.comment-title-white-text {\n				font-size: 20px;\n				font-style: normal;\n				font-weight: bold;\n				line-height: normal;\n				padding: 10px 10px;\n				color: var(--card-bg);\n			}\n\n			.comment-title {\n				font-size: 20px;\n				font-style: normal;\n				font-weight: bold;\n				line-height: normal;\n				padding: 10px 20px;\n				color: rgb(8, 126, 255);\n			}\n\n			.comment-title-start-date {\n				font-size: 20px;\n				font-style: normal;\n				font-weight: bold;\n				line-height: normal;\n				padding: 10px 20px;\n				color: var(--card-bg);\n			}\n\n			.comment-contents-white-text {\n				font-size: 18px;\n				font-style: normal;\n				font-weight: bold;\n				line-height: normal;\n				padding: 10px 10px 5px;\n				color: var(--card-bg);\n			}\n\n			.comment-contents {\n				font-size: 18px;\n				font-style: normal;\n				font-weight: bold;\n				line-height: normal;\n				padding: 10px 10px 5px;\n				color: rgb(8, 126, 255);\n			}\n\n			.comment-item-box {\n				margin: 0;\n				padding: 10px 20px;\n				padding-left: 40px;\n			}\n		}\n	}\n\n	.bold {\n		font-weight: bold;\n	}\n\n	.desc-list {\n		padding-left: 20px;\n		margin-top: 0px;\n	}\n\n	.subheading-nopadding {\n		font-size: 20px;\n		font-weight: bold;\n		white-space: pre-wrap;\n		position: relative;\n	}\n\n	.price-title-box {\n		display: flex;\n		flex-direction: row;\n		justify-content: start;\n		align-items: baseline;\n		flex-wrap: wrap;\n		gap: 10px;\n\n		.vat-info {\n			font-size: 16px;\n			font-weight: 400;\n		}\n	}\n\n	.payment-info-box {\n		display: flex;\n		flex-direction: row;\n		justify-content: space-between;\n		align-items: center;\n		flex-wrap: wrap;\n		gap: 10px;\n\n		.guide-info {\n			font-size: 14px;\n			font-weight: 400;\n		}\n\n		.payment-info {\n			font-size: 16px;\n			font-weight: 400;\n			display: flex;\n			flex-direction: row;\n			justify-content: center;\n			align-items: center;\n		}\n\n		.bold {\n			font-weight: bold;\n		}\n	}\n\n	.buttonBox {\n		display: flex;\n		flex-direction: row;\n	}\n\n	.btn {\n		flex: 1;\n		font-size: 18px;\n		border-radius: 15px;\n		font-weight: bold;\n	}\n\n	.buttonBox > .first {\n		margin-right: 15px;\n	}\n\n	.onpoint-comment {\n		display: flex;\n		flex-direction: column;\n		justify-content: center;\n		align-items: center;\n		text-align: left;\n\n		.onpoint-comment-guide {\n			color: var(--primary);\n			width: 100%;\n			margin-bottom: 10px;\n			padding-top: 15px;\n		}\n\n		.onpoint-comment-desc {\n			width: 100%;\n			//\n		}\n\n		.white {\n			color: white;\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	border: 0.3px solid var(--card-bg);\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	border: 0.3px solid #eeeeee;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	border: 0.3px solid #666666;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	flex-direction: column;\n\n	.top {\n		display: flex;\n		flex-direction: row;\n		justify-content: space-between;\n\n		#top-title {\n			color: var(--card-bg);\n			font-size: 35px;\n			font-weight: 800;\n			line-height: normal;\n		}\n\n		#top-text {\n			margin-top: 8px;\n			color: var(--card-bg);\n			font-size: 20px;\n			font-weight: 600;\n			line-height: normal;\n		}\n\n		.logo {\n			width: 50px;\n			height: 50px;\n			margin-left: 16px;\n		}\n\n		.description {\n			//\n			font-size: 16px;\n			color: #888888;\n		}\n	}\n\n	.intro {\n		margin-top: 36px;\n		width: 100%;\n\n		#intro-title {\n			color: var(--card-bg);\n			font-size: 20px;\n			font-weight: 400;\n			line-height: normal;\n		}\n\n		#intro-data {\n			color: var(--card-bg);\n			font-size: 16px;\n			font-weight: 400;\n			margin-top: 14px;\n			line-height: 28px;\n		}\n	}\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var BottomWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject());
var Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject1());
var WrapperContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject2());
var Line = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject3());
var LightLine = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject4());
var SuperLightLine = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject5());
var TitleComponent = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "top",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            id: "top-title",
                            children: props.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            id: "top-text",
                            children: props.subtitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "description",
                            children: props.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        className: "logo",
                        src: "/static/image/logo_white.svg"
                    })
                })
            ]
        })
    });
};
var TitleComponentWithWhiteBlueLogo = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "top",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            id: "top-title",
                            children: props.title
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            id: "top-text",
                            children: props.subtitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: "description",
                            children: props.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                        className: "logoImg",
                        src: "/onepoint/assets/images/logo/h-logo_bl.png",
                        style: {
                            width: "180px"
                        }
                    })
                })
            ]
        })
    });
};
var TitleWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .Z.div(_templateObject6());


/***/ }),

/***/ 2035:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ OtherProfile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 3 modules
var emotion_styled_browser_esm = __webpack_require__(77366);
// EXTERNAL MODULE: ./src/api/profile.ts
var profile = __webpack_require__(95250);
// EXTERNAL MODULE: ./src/hook/useLoader.ts
var useLoader = __webpack_require__(26076);
// EXTERNAL MODULE: ./src/ruix/index.ts + 22 modules
var ruix = __webpack_require__(9869);
// EXTERNAL MODULE: ./src/state/index.ts
var state = __webpack_require__(51413);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/recoil/es/index.js
var recoil_es = __webpack_require__(4480);
// EXTERNAL MODULE: ./src/component/SignComponent.tsx
var SignComponent = __webpack_require__(34489);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ThumbUpOutlined.js
var ThumbUpOutlined = __webpack_require__(85268);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Verified.js
var Verified = __webpack_require__(59382);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61225);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(17575);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./src/utils/CalculationUtils.ts
var CalculationUtils = __webpack_require__(81812);
// EXTERNAL MODULE: ./node_modules/linkify-react/dist/linkify-react.es.js + 1 modules
var linkify_react_es = __webpack_require__(4913);
;// CONCATENATED MODULE: ./src/component/profile/other/Section1.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--desc-gray);\n	font-size: 16px;\n	font-weight: 500;\n	line-height: normal;\n	letter-spacing: -0.64px;\n	line-height: 150%; /* 24px */\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	color: var(--card-bg);\n	font-size: 16px;\n	font-style: normal;\n	font-weight: 700;\n	line-height: 150%; /* 24px */\n	letter-spacing: -0.64px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n\n	.contents {\n		color: var(--card-bg);\n		display: flex;\n	}\n\n	.top {\n		display: flex;\n		flex-direction: column;\n		width: 100%;\n\n		.ai-summary-slot {\n			width: 100%;\n		}\n\n		.top-title-box {\n			display: flex;\n			flex-direction: row;\n			width: 100%;\n			align-items: center;\n			justify-content: space-between;\n\n			.top-title-with-badge {\n				display: flex;\n				flex-direction: row;\n				align-items: center;\n\n				.badge-container {\n					position: relative;\n					display: inline-block;\n\n					.best-expert-badge {\n						width: 75px;\n						height: 75px;\n						flex-shrink: 0;\n						display: block;\n						animation: badge-appear 0.5s ease-out;\n					}\n\n					.badge-info-button {\n						position: absolute;\n						top: 7px;\n						right: 7px;\n						padding: 3px;\n						background-color: transparent;\n\n						&:hover {\n							background-color: rgba(255, 255, 255, 0.3);\n						}\n\n						.badge-info-icon {\n							width: 11px;\n							height: 11px;\n							color: var(--primary);\n						}\n					}\n				}\n\n				@keyframes badge-appear {\n					from {\n						opacity: 0;\n						transform: scale(0.8);\n					}\n					to {\n						opacity: 1;\n						transform: scale(1);\n					}\n				}\n			}\n\n			.toptier {\n				display: flex;\n				flex-direction: row;\n				gap: 4px;\n				align-items: center;\n				a {\n					color: var(--primary);\n					font-size: 16px;\n					font-weight: 600;\n					line-height: normal;\n					text-decoration: underline;\n				}\n			}\n		}\n\n		@media screen and (max-width: 768px) {\n			.top-title-box {\n				display: flex;\n				flex-direction: column;\n				width: 100%;\n				align-items: flex-start;\n				gap: 8px;\n				margin-bottom: 20px;\n\n				.top-title-with-badge {\n					.best-expert-badge {\n						width: 100px;\n						height: 100px;\n					}\n				}\n			}\n		}\n\n		.top-title {\n			color: var(--card-bg);\n			font-size: 35px;\n			font-weight: 800;\n			line-height: normal;\n		}\n\n		.top-text {\n			margin-top: 8px;\n			color: var(--card-bg);\n			font-size: 20px;\n			font-weight: 600;\n			line-height: normal;\n		}\n\n		.logo {\n			width: 50px;\n			height: 50px;\n			margin-left: 16px;\n		}\n	}\n\n	.intro {\n		margin-top: 18px;\n		width: 100%;\n\n		#intro-title {\n			color: var(--desc-gray);\n			font-size: 20px;\n			font-weight: 400;\n			line-height: normal;\n		}\n\n		#intro-data {\n			color: var(--desc-gray);\n			font-size: 16px;\n			font-weight: 400;\n			margin-top: 14px;\n			line-height: 28px;\n\n			.linkify {\n				color: var(--primary);\n				cursor: pointer;\n			}\n\n			a {\n				text-decoration: underline;\n			}\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}










var BEST_EXPERT_2024_NICKNAMES = [
    "용지니",
    "hidy",
    "key",
    "Zoe B",
    "nry",
    "유진",
    "루시",
    "에드",
    "seanine",
    "C2",
    "M-J",
    "허프",
    "데이",
    "해인",
    "범쌤",
    "손희수",
    "날뛰는캥거루",
    "엠마",
    "필립",
    "연수이", 
];
// 2025 Best Expert 닉네임 목록
var BEST_EXPERT_2025_NICKNAMES = [
    "hidy",
    "AmandaLee",
    "스카이",
    "올라운더해나",
    "강제인",
    "sjsj",
    "hani",
    "조조",
    "nomadbellaaa",
    "Zoe B",
    "소정",
    "tami",
    "key",
    "댄디라이언",
    "유진",
    "지구인",
    "리드젠 엑스퍼트",
    "nry",
    "스텔라송",
    "TAM",
    "용지니", 
];
var Section1 = function(param) {
    var data = param.data, showOpenPrice = param.showOpenPrice, isRecommended = param.isRecommended, aiSummarySlot = param.aiSummarySlot;
    var isMobile = (0,useMediaQuery/* default */.Z)("(max-width:700px)");
    var isBestExpert2025 = data.name && BEST_EXPERT_2025_NICKNAMES.includes(data.name);
    var isBestExpert2024 = data.name && BEST_EXPERT_2024_NICKNAMES.includes(data.name);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "top-title-box",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "top-title-with-badge",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "top-title",
                                        children: data.name
                                    }),
                                    isBestExpert2024 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "badge-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/onepoint/assets/images/icon/2024_bey.svg",
                                                alt: "2024 Best Expert",
                                                className: "best-expert-badge"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                title: "2024년 최고의 전문가 19인에 선정된 전문가입니다!",
                                                placement: "top",
                                                arrow: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                    className: "badge-info-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                                        className: "badge-info-icon"
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    isBestExpert2025 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "badge-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/onepoint/assets/images/icon/2025_bey.svg",
                                                alt: "2025 Best Expert",
                                                className: "best-expert-badge"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                title: "2025년 최고의 전문가 20인에 선정된 전문가입니다!",
                                                placement: "top",
                                                arrow: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                                    className: "badge-info-button",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                                        className: "badge-info-icon"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "toptier-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "toptier",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified/* default */.Z, {
                                                sx: {
                                                    fill: "var(--primary)"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://notion.1point.kr/toptier",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "원포인트 검증 전문가"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                        space: 10
                                    }),
                                    isRecommended ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "toptier",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThumbUpOutlined/* default */.Z, {
                                                sx: {
                                                    fill: "var(--primary)"
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://notion.1point.kr/toptier",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                children: "원포인트 추천 전문가"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "top-text",
                        children: [
                            data.job,
                            " ",
                            data.year ? data.year + "년차" : ""
                        ]
                    }),
                    aiSummarySlot ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                space: 14
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "ai-summary-slot",
                                children: aiSummarySlot
                            })
                        ]
                    }) : null
                ]
            }),
            data.briefDescription && data.briefDescription.data != "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "intro",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "intro-data",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(linkify_react_es/* default */.Z, {
                        as: "span",
                        options: {
                            className: "linkify",
                            target: "_blank"
                        },
                        children: data.briefDescription.data
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 30
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                fullWidth: true,
                order: "row-start-start",
                gap: 30,
                children: [
                    showOpenPrice && data.openPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                        order: "column-start-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "시간당 금액"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubTitle, {
                                children: [
                                    (0,CalculationUtils/* numberWithCommasFromNumber */.tw)(data.openPrice),
                                    "원/1시간"
                                ]
                            })
                        ]
                    }) : null,
                    data.year && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                        order: "column-start-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "연차"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubTitle, {
                                children: [
                                    data.year,
                                    "년차"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                        order: "column-start-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "현 상태"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                children: data.currentStatus
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                        order: "column-start-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: "업무 가능 시간"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                                children: data.jobTime
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var Title = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
var SubTitle = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
var Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./src/component/base/BasicFormWrapper.tsx
var BasicFormWrapper = __webpack_require__(66660);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/component/profile/components/ProfileEducationItem.tsx

function ProfileEducationItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n\n	.one-point {\n		color: var(--primary);\n		font-size: 16px;\n		font-weight: bold;\n	}\n\n	.top {\n		display: flex;\n		flex-direction: row;\n		justify-content: space-between;\n		flex-wrap: wrap;\n		align-items: flex-start;\n\n		.title-box {\n			color: var(--card-bg);\n			font-size: 20px;\n			font-weight: 700;\n			line-height: normal;\n		}\n\n		.duration {\n			white-space: pre-wrap;\n			font-weight: 700;\n		}\n	}\n\n	.content {\n		display: flex;\n		flex-direction: column;\n		margin-top: 12px;\n\n		color: var(--desc-gray);\n		font-size: 16px;\n		font-weight: 400;\n		line-height: 28px;\n\n		white-space: pre-wrap;\n	}\n"
    ]);
    ProfileEducationItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ProfileEducationItem = function(param) {
    var school = param.school, major = param.major, start = param.start, end = param.end, isCurrent = param.isCurrent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileEducationItem_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-box",
                        children: school
                    }),
                    start && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "duration",
                        children: isCurrent ? "".concat(moment_default()(start).format("YYYY.MM"), " ~ 현재") : "".concat(moment_default()(start).format("YYYY.MM"), " ~ ").concat(moment_default()(end).format("YYYY.MM"))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: major
                })
            })
        ]
    });
};
var ProfileEducationItem_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(ProfileEducationItem_templateObject());

// EXTERNAL MODULE: ./src/component/profile/components/ProfileListItem.tsx
var ProfileListItem = __webpack_require__(22240);
;// CONCATENATED MODULE: ./src/component/profile/components/ProfileProjectItem.tsx

function ProfileProjectItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n\n	.one-point {\n		color: var(--primary);\n		font-size: 16px;\n		font-weight: bold;\n		letter-spacing: -0.64px;\n	}\n\n	.top {\n		display: flex;\n		flex-direction: row;\n		justify-content: space-between;\n		flex-wrap: wrap;\n		align-items: flex-start;\n\n		.title-box {\n			color: var(--card-bg);\n			font-size: 20px;\n			font-weight: 700;\n			line-height: normal;\n\n			letter-spacing: -0.64px;\n		}\n\n		.contribution {\n			color: var(--primary);\n			white-space: pre-wrap;\n			font-weight: 700;\n\n			letter-spacing: -0.64px;\n		}\n	}\n\n	.content {\n		display: flex;\n		flex-direction: column;\n		margin-top: 24px;\n\n		color: var(--desc-gray);\n		font-size: 16px;\n		font-weight: 400;\n		line-height: 150%;\n		letter-spacing: -0.64px;\n\n		white-space: pre-wrap;\n	}\n"
    ]);
    ProfileProjectItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





var ProfileProjectItem = function(param) {
    var data = param.data, title = param.title, contribution = param.contribution, isOnePoint = param.isOnePoint;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileProjectItem_Wrapper, {
        children: [
            isOnePoint && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ruix/* GroupA */.so, {
                        order: "row-center-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Verified/* default */.Z, {
                                sx: {
                                    fill: "var(--primary)"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "one-point",
                                children: "원포인트 진행 프로젝트"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                        space: 4
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "top",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title-box",
                        children: title
                    }),
                    contribution ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "contribution",
                        children: [
                            "기여도 ",
                            contribution,
                            "%"
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content",
                children: data
            })
        ]
    });
};
var ProfileProjectItem_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(ProfileProjectItem_templateObject());

;// CONCATENATED MODULE: ./src/component/profile/components/ProfileRecordItem.tsx

function ProfileRecordItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	flex-basis: 130px;\n	width: 130px;\n	flex-grow: 0;\n	flex-shrink: 0;\n	gap: 4px;\n	.group-a {\n		flex-basis: 130px;\n		width: 130px;\n		flex-grow: 0;\n		flex-shrink: 0;\n	}\n"
    ]);
    ProfileRecordItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfileRecordItem_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: row;\n	justify-content: start;\n	align-items: flex-start;\n	gap: 10px;\n\n	@media screen and (max-width: 768px) {\n		flex-direction: column;\n		align-items: start;\n		justify-content: start;\n		gap: 10px;\n	}\n\n	.top {\n		display: flex;\n		flex-direction: row;\n		justify-content: space-between;\n	}\n\n	.title {\n		color: var(--card-bg);\n		font-size: 20px;\n		font-weight: 700;\n		line-height: normal;\n		letter-spacing: -0.64px;\n		word-break: break-all;\n		white-space: pre-wrap !important;\n		width: auto !important;\n	}\n\n	.subTitle {\n		color: var(--card-bg);\n		font-size: 16px;\n		font-weight: 700;\n		line-height: normal;\n		letter-spacing: -0.64px;\n		word-break: break-all;\n	}\n\n	.date {\n		color: var(--desc-gray);\n		font-size: 12px;\n		font-weight: 400;\n		line-height: normal;\n		white-space: nowrap;\n		letter-spacing: -0.64px;\n	}\n\n	.period {\n		color: var(--desc-gray);\n		font-size: 12px;\n		font-weight: 400;\n		line-height: normal;\n		white-space: nowrap;\n		text-align: right;\n		letter-spacing: -0.64px;\n	}\n\n	.content {\n		display: flex;\n		flex-direction: column;\n		color: var(--desc-gray);\n		font-size: 16px;\n		font-weight: 500;\n		line-height: 150%;\n		letter-spacing: -0.64px;\n	}\n"
    ]);
    ProfileRecordItem_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var ProfileRecordItem = function(param) {
    var companyName = param.companyName, position = param.position, start = param.start, end = param.end, job = param.job, isCurrent = param.isCurrent;
    var startDate = moment_default()(new Date(start));
    var endDate = moment_default()(new Date(end));
    var diffDuration = moment_default().duration(endDate.diff(startDate));
    var diffYear = diffDuration.years();
    var diffMonth = diffDuration.months();
    var formattedDiffDate = (diffYear > 0 ? "".concat(diffYear, "년") : "") + (diffMonth > 0 ? "".concat(diffMonth, "개월") : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileRecordItem_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledGroupA, {
                className: "column-start-start",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "title",
                        children: companyName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "subTitle",
                        children: position
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "date-box column-start-start",
                        children: isCurrent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "date",
                                    children: [
                                        startDate.format("yyyy.MM"),
                                        " ~ ",
                                        "현재"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "period",
                                    children: "재직중"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "date",
                                    children: [
                                        startDate.format("yyyy.MM"),
                                        " ~ ",
                                        endDate.format("yyyy.MM")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "period",
                                    children: [
                                        formattedDiffDate,
                                        " (재직기간)"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "content",
                children: job
            })
        ]
    });
};
var StyledGroupA = emotion_styled_browser_esm/* default.div */.Z.div(ProfileRecordItem_templateObject());
var ProfileRecordItem_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(ProfileRecordItem_templateObject1());

;// CONCATENATED MODULE: ./src/component/profile/other/Section2.tsx


function Section2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n\n	.title {\n		color: var(--card-bg);\n		font-size: 27px;\n		font-weight: 800;\n		line-height: normal;\n		white-space: nowrap;\n		width: 180px;\n\n		@media screen and (max-width: 900px) {\n			width: auto;\n			margin-right: 20px;\n		}\n	}\n\n	.record-content-wrapper {\n		display: flex;\n		flex-direction: column;\n\n		.record-content-box {\n			display: flex;\n			flex-direction: row;\n\n			@media screen and (max-width: 900px) {\n				flex-direction: column;\n			}\n\n			.record-title {\n				color: var(--card-bg);\n				font-size: 27px;\n				font-weight: 800;\n				line-height: normal;\n				white-space: nowrap;\n				width: 100px;\n			}\n\n			.record-content {\n				display: flex;\n				flex-direction: column;\n				flex-grow: 1;\n				margin-left: 70px;\n\n				@media screen and (max-width: 900px) {\n					margin-top: 20px;\n					margin-left: 0px;\n				}\n			}\n		}\n	}\n\n	.subheading {\n		font-size: 24px;\n		font-weight: bold;\n		white-space: pre-wrap;\n		padding-bottom: 10px;\n		position: relative;\n	}\n\n	.desc {\n		font-size: 16px;\n		white-space: pre-wrap;\n		padding-bottom: 40px;\n\n		> a {\n			text-decoration: underline;\n		}\n	}\n\n	.project-content-wrapper {\n		display: flex;\n		flex-direction: column;\n\n		.project-content-box {\n			display: flex;\n			flex-direction: row;\n\n			@media screen and (max-width: 900px) {\n				flex-direction: column;\n			}\n\n			.project-title {\n				color: var(--card-bg);\n				font-size: 27px;\n				font-weight: 800;\n				line-height: normal;\n				white-space: nowrap;\n				width: 100px;\n			}\n\n			.project-content {\n				display: flex;\n				flex-direction: column;\n				margin-left: 70px;\n				flex-grow: 1;\n\n				@media screen and (max-width: 900px) {\n					margin-left: 0;\n					margin-top: 20px;\n				}\n			}\n		}\n	}\n\n	.detail-content-wrapper {\n		display: flex;\n		flex-direction: column;\n		margin-bottom: 30px;\n\n		#detail-title {\n			color: var(--card-bg);\n			font-size: 27px;\n			font-weight: 800;\n			line-height: normal;\n			white-space: nowrap;\n		}\n	}\n\n	.skill-special-box {\n		display: flex;\n		flex-direction: row;\n		align-items: flex-start;\n		justify-content: center;\n		flex-wrap: wrap;\n	}\n\n	.skill-box {\n		display: flex;\n		flex-direction: row;\n\n		.skill-title {\n			width: 150px;\n			margin-right: 0px;\n			color: var(--card-bg);\n			font-size: 27px;\n			font-weight: 800;\n			line-height: normal;\n			white-space: nowrap;\n			flex: 0;\n		}\n\n		.skill-item-box {\n			display: flex;\n			flex-direction: row;\n			align-items: start;\n			justify-content: left;\n			flex-grow: 1;\n			flex-wrap: wrap;\n			gap: 20px;\n			margin-left: 70px;\n\n			.skill-item {\n				color: var(--desc-gray);\n				font-size: 14px;\n				font-weight: bold;\n				padding: 5px 10px;\n				border-radius: 4px;\n				background-color: var(--bg-white);\n			}\n		}\n\n		@media screen and (max-width: 900px) {\n			flex-direction: column;\n			gap: 10px;\n\n			.skill-item-box {\n				margin-left: 0px;\n			}\n		}\n	}\n\n	.show-more-button {\n		margin-top: 20px;\n		padding: 10px 20px;\n		font-size: 14px;\n		font-weight: bold;\n		border: none;\n		border-radius: 20px;\n		background-color: var(--bg-white);\n		color: var(--desc-gray);\n		cursor: pointer;\n	}\n\n	.portfolio-content-wrapper {\n		display: flex;\n		flex-direction: column;\n\n		.portfolio-content-box {\n			display: flex;\n			flex-direction: row;\n\n			.title {\n				width: 170px;\n				margin-right: 0px;\n			}\n\n			.portfolio-link-box {\n				display: flex;\n				flex-direction: row;\n				align-items: center;\n				justify-content: left;\n				flex-grow: 1;\n\n				img {\n					width: 20px;\n					height: 20px;\n				}\n\n				.portfolio-link {\n					color: var(--primary);\n					color: var(--primary);\n					font-size: 18px;\n					font-weight: 600;\n					line-height: normal;\n					text-decoration-line: underline;\n					margin-left: 5px;\n				}\n			}\n		}\n	}\n\n	.comment-content-wrapper {\n		display: flex;\n		flex-direction: column;\n\n		.comment-box {\n			background-color: #303030;\n			padding: 10px;\n\n			.comment-title {\n				font-size: 25px;\n				font-style: normal;\n				font-weight: 800;\n				line-height: normal;\n				padding: 10px 20px;\n				color: rgb(8, 126, 255);\n			}\n\n			.comment-item-box {\n				display: flex;\n				flex-direction: row;\n				align-items: center;\n				padding: 10px 20px;\n			}\n\n			.comment-item-box2 {\n				display: flex;\n				flex-direction: column;\n				align-items: start;\n				padding: 10px 20px;\n			}\n\n			.comment-item-title {\n				font-size: 20px;\n				font-style: normal;\n				font-weight: bold;\n				color: var(--card-bg);\n				white-space: wrap;\n				flex-grow: 2;\n			}\n\n			.comment-item {\n				color: #fff;\n				display: flex;\n				flex-direction: row;\n				align-items: start;\n				justify-content: left;\n				flex-grow: 1;\n				flex-wrap: wrap;\n				gap: 20px;\n				margin-left: 30px;\n				font-size: 16px;\n				flex-grow: 3;\n\n				.skill {\n					color: #fff;\n					font-size: 13px;\n					font-weight: 500;\n					padding: 5px 10px;\n					border-radius: 20px;\n					background-color: #404040;\n				}\n			}\n\n			.comment-desc {\n				color: #fff;\n				display: flex;\n				flex-direction: row;\n				align-items: start;\n				justify-content: left;\n				flex-grow: 1;\n				flex-wrap: wrap;\n				gap: 20px;\n				font-size: 16px;\n				margin-top: 10px;\n\n				.linkify {\n					color: var(--primary);\n					cursor: pointer;\n				}\n\n				a {\n					text-decoration: underline;\n				}\n			}\n		}\n\n		.comment-content-box {\n			display: flex;\n			flex-direction: column;\n\n			@media screen and (max-width: 900px) {\n				flex-direction: column;\n			}\n\n			.comment {\n				color: #fff;\n				font-size: 16px;\n				font-weight: 400;\n				line-height: 28px;\n				white-space: pre-wrap;\n\n				@media screen and (max-width: 900px) {\n					margin-top: 20px;\n				}\n			}\n		}\n	}\n\n	.testsession-content-wrapper {\n		display: flex;\n		flex-direction: row;\n		width: 100%;\n\n		.testsession-content-box {\n			display: flex;\n			flex-direction: column;\n			width: 100%;\n			color: var(--desc-gray);\n			font-size: 16px;\n			font-weight: 400;\n			line-height: 28px;\n			white-space: pre-wrap;\n			align-items: center;\n\n			.top {\n				display: flex;\n				flex-direction: column;\n				width: 100%;\n				align-items: center;\n				text-align: center;\n\n				@media screen and (max-width: 900px) {\n					flex-direction: column;\n					width: 100%;\n					text-align: left;\n				}\n			}\n\n			.sub-title {\n				@media screen and (max-width: 900px) {\n					margin-top: 20px;\n				}\n			}\n\n			.btn {\n				border-radius: 30px;\n				border: 2px solid var(--primary);\n				font-size: 20px;\n				font-weight: 700;\n				max-width: 450px;\n				width: 100%;\n				padding: 10px;\n\n				@media screen and (max-width: 768px) {\n					font-size: 16px;\n				}\n			}\n\n			.testsession-btn {\n				background-color: var(--primary);\n				border-radius: 30px;\n\n				font-size: 20px;\n				font-weight: 700;\n				max-width: 450px;\n				width: 100%;\n				padding: 10px;\n			}\n\n			a {\n				color: var(--primary);\n				text-decoration: underline;\n			}\n		}\n	}\n"
    ]);
    Section2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}










var Section2 = function(param) {
    var data = param.data, matchUuid = param.matchUuid, matchedSkills = param.matchedSkills, matchedExpertDataUuid = param.matchedExpertDataUuid, isNoShowButton = param.isNoShowButton, noShowPortfolio = param.noShowPortfolio;
    var records = data.records;
    var projects = data.projects;
    var educations = data.educations;
    var isV2 = !!(records && records.length > 0);
    if ((records === null || records === void 0 ? void 0 : records.length) == 1 && records[0].companyName == "") isV2 = false;
    var getMatchSkills = function(str, arr) {
        var matchSkillsArr = str.split(",").map(function(s) {
            return s.trim();
        }).filter(function(s) {
            return s.length > 0;
        });
        return matchSkillsArr.map(function(skill) {
            return {
                skill: skill,
                isBold: arr.includes(skill)
            };
        }).sort(function(a, b) {
            if (a.isBold && !b.isBold) return -1;
            else if (!a.isBold && b.isBold) return 1;
            else return 0;
        });
    };
    var containerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showMore = ref[0], setShowMore = ref[1];
    var ref1 = (0,react.useState)(false), isOverflowing = ref1[0], setIsOverflowing = ref1[1];
    var containerRef2 = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(false), showMore2 = ref2[0], setShowMore2 = ref2[1];
    var ref3 = (0,react.useState)(false), isOverflowing2 = ref3[0], setIsOverflowing2 = ref3[1];
    var ref4 = (0,react.useState)(0), windowWidth = ref4[0], setWindowWidth = ref4[1];
    var handleResize = function() {
        setWindowWidth(window.innerWidth);
    };
    (0,react.useEffect)(function() {
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    (0,react.useEffect)(function() {
        var ref, ref1;
        var containerHeight = (containerRef === null || containerRef === void 0 ? void 0 : (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight) || 0;
        var scrollHeight = (containerRef === null || containerRef === void 0 ? void 0 : (ref1 = containerRef.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight) || 0;
        if (scrollHeight > containerHeight) {
            setIsOverflowing(true);
        } else {
            setIsOverflowing(false);
        }
    }, [
        showMore,
        windowWidth
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        var containerHeight = (containerRef2 === null || containerRef2 === void 0 ? void 0 : (ref = containerRef2.current) === null || ref === void 0 ? void 0 : ref.clientHeight) || 0;
        var scrollHeight = (containerRef2 === null || containerRef2 === void 0 ? void 0 : (ref1 = containerRef2.current) === null || ref1 === void 0 ? void 0 : ref1.scrollHeight) || 0;
        if (scrollHeight > containerHeight) {
            setIsOverflowing2(true);
        } else {
            setIsOverflowing2(false);
        }
    }, [
        showMore2,
        windowWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Section2_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                children: [
                    data.specialization && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* Line */.x1, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                space: 30
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sm: 12,
                                md: 12,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "detail-content-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "skill-box",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "skill-title",
                                                    children: "전문 분야"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "skill-item-box",
                                                    style: {
                                                        maxHeight: showMore2 ? "none" : "150px",
                                                        overflow: "hidden"
                                                    },
                                                    ref: containerRef2,
                                                    children: data.specialization.split(",").map(function(skillData, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "skill-item",
                                                                children: skillData
                                                            })
                                                        }, "specialitem".concat(i));
                                                    })
                                                })
                                            ]
                                        }),
                                        isOverflowing2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            onClick: function() {
                                                return setShowMore2(!showMore2);
                                            },
                                            className: "show-more-button",
                                            children: showMore ? "접기" : "더보기"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    data.skill && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        sm: 12,
                        md: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "detail-content-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "skill-box",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "skill-title",
                                            children: "보유 스킬"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "skill-item-box",
                                            style: {
                                                maxHeight: showMore ? "none" : "150px",
                                                overflow: "hidden"
                                            },
                                            ref: containerRef,
                                            children: getMatchSkills(data.skill, matchedSkills).map(function(skillData, i) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        style: {
                                                            backgroundColor: skillData.isBold ? "var(--primary)" : "var(--bg-white)",
                                                            color: skillData.isBold ? "var(--bg-white)" : "var(--desc-gray)"
                                                        },
                                                        className: "skill-item",
                                                        children: skillData.skill
                                                    })
                                                }, "skillitem".concat(i));
                                            })
                                        })
                                    ]
                                }),
                                isOverflowing && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    onClick: function() {
                                        return setShowMore(!showMore);
                                    },
                                    className: "show-more-button",
                                    children: showMore ? "접기" : "더보기"
                                })
                            ]
                        })
                    })
                ]
            }),
            isV2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    records && records.length > 0 && records[0].companyName != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "record-content-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* Line */.x1, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                space: 30
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "record-content-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "record-title",
                                        children: "주요 이력"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "record-content",
                                        children: records.map(function(record, i) {
                                            return record.companyName != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileRecordItem, (0,_object_spread/* default */.Z)({}, record)),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                                        space: 30
                                                    }),
                                                    i === records.length - 1 ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* LightLine */.vo, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                                                space: 30
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    projects && projects.length > 0 && projects[0].title != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "project-content-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* Line */.x1, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                space: 30
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "project-content-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "project-title",
                                        children: "프로젝트"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "project-content",
                                        children: projects.map(function(project, i) {
                                            return project.title != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileProjectItem, (0,_object_spread/* default */.Z)({}, project)),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                                        space: 30
                                                    }),
                                                    i === projects.length - 1 ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* LightLine */.vo, {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                                                space: 30
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isV2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* Line */.x1, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                        space: 30
                    }),
                    data.resume && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "subheading",
                                children: "주요 이력"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* LightLine */.vo, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                space: 10
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                children: data.resume
                            })
                        ]
                    }),
                    data.project && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "subheading",
                                children: "프로젝트"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* LightLine */.vo, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                space: 10
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "desc",
                                children: data.project
                            })
                        ]
                    })
                ]
            }),
            educations && educations.length > 0 && educations[0].school != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "project-content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* Line */.x1, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                        space: 30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "project-content-box",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "project-title",
                                children: "학력"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "project-content",
                                children: educations.map(function(education, i) {
                                    return education.school != "" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileEducationItem, (0,_object_spread/* default */.Z)({}, education)),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                                space: 20
                                            }),
                                            i === educations.length - 1 ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* LightLine */.vo, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                                        space: 20
                                                    })
                                                ]
                                            })
                                        ]
                                    }, i + "education-profile-item");
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                space: 20
            }),
            data.portfolioMasking && !noShowPortfolio ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "portfolio-content-wrapper",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* Line */.x1, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                space: 30
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "portfolio-content-box",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "title",
                                        children: "외부 링크"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "portfolio-link-box",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/static/image/link.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "portfolio-link",
                                                target: "_blank",
                                                href: data.portfolioMasking,
                                                rel: "noreferrer",
                                                children: "포트폴리오"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                        space: 30
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "detail-content-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* Line */.x1, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                        space: 30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        id: "detail-title",
                        children: "세부 경험"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                        space: 20
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        style: {
                            margin: 0,
                            padding: 0,
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem/* default */.Z, {
                                invisibleOption: true,
                                text: data.businessType,
                                title: "기업 유형",
                                dark: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem/* default */.Z, {
                                invisibleOption: true,
                                text: data.business,
                                title: "비즈니스 유형",
                                dark: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem/* default */.Z, {
                                invisibleOption: true,
                                text: data.industry,
                                title: "산업군",
                                dark: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem/* default */.Z, {
                                invisibleOption: true,
                                text: data.country,
                                title: "업무 가능 시장",
                                dark: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileListItem/* default */.Z, {
                                invisibleOption: true,
                                text: data.language,
                                title: "업무 가능 언어",
                                dark: true
                            })
                        ]
                    })
                ]
            }),
            matchedExpertDataUuid && !isNoShowButton && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicFormWrapper/* Line */.x1, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                        space: 30
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "testsession-content-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "testsession-content-box",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                    space: 20
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "",
                                    children: "추천받은 모든 전문가 프로필에 대해 인터뷰 수락 또는 거절 의사를 밝혀주세요."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                                    space: 2
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "",
                                    children: [
                                        "원활한 인터뷰 진행을 위해 ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "guide-link",
                                            target: "_blank",
                                            href: "https://notion.1point.kr/service/guide/test",
                                            rel: "noreferrer",
                                            children: "가이드라인"
                                        }),
                                        "을 확인해주세요."
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var Section2_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(Section2_templateObject());

;// CONCATENATED MODULE: ./src/component/profile/other/Section3.tsx

function Section3_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n	align-items: center;\n	color: var(--card-bg);\n\n	max-width: 80%;\n	text-align: center;\n\n	.title {\n		font-size: 24px;\n		font-weight: 800;\n	}\n\n	.sub-title {\n		font-size: 16px;\n		font-weight: 400;\n		white-space: pre-wrap;\n	}\n\n	.help {\n		font-size: 15px;\n		a {\n			text-decoration: underline;\n			color: var(--primary);\n		}\n	}\n\n	.btn {\n		border-radius: 30px;\n		border: 2px solid var(--primary);\n		background-color: transparent;\n		font-size: 20px;\n		font-weight: 700;\n		max-width: 450px;\n		width: 100%;\n		padding: 10px;\n\n		@media screen and (max-width: 768px) {\n			font-size: 16px;\n		}\n	}\n"
    ]);
    Section3_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Section3 = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section3_Wrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "help",
            children: [
                "문의사항은 담당 매칭 컨설턴트 또는",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://1point.channel.io/home",
                    target: "blank",
                    children: "여기를 클릭해"
                }),
                " ",
                "주세요",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                    space: 20
                })
            ]
        })
    });
};
var Section3_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(Section3_templateObject());

;// CONCATENATED MODULE: ./src/component/profile/OtherProfile.tsx



function OtherProfile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	width: 100%;\n	height: 100%;\n	overflow: auto;\n	display: flex;\n	flex-direction: column;\n	align-items: center;\n	height: fit-content;\n\n	* {\n		white-space: pre-wrap;\n		word-break: break-all;\n	}\n"
    ]);
    OtherProfile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function OtherProfile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	max-width: 1000px;\n	width: 100%;\n	background-color: #fff;\n	border-radius: 30px 30px 0 0;\n	padding: 30px;\n	display: flex;\n	flex-direction: column;\n	justify-content: center;\n\n	@media screen and (max-width: 768px) {\n		padding: 10px;\n		width: 100%;\n		border-radius: 10px 10px 0 0;\n	}\n"
    ]);
    OtherProfile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}














var OtherProfile = function(param) {
    var matchUuid = param.matchUuid, expertUuid = param.expertUuid, matchedExpertDataUuid = param.matchedExpertDataUuid, isNoShowButton = param.isNoShowButton, om = param.om, direct = param.direct, direct2 = param.direct2, isRecommended = param.isRecommended, omCallback = param.omCallback, aiSummarySlot = param.aiSummarySlot;
    var router = (0,next_router.useRouter)();
    var withLoader = (0,useLoader/* default */.Z)();
    var ref = (0,react.useState)(), expertInfo = ref[0], setExpertInfo = ref[1];
    var setSnackbareState = (0,recoil_es/* useSetRecoilState */.Zl)(state/* globalSnackbarState */.j8);
    var profileQueryParameter = [
        "getProfile",
        expertUuid,
        matchUuid
    ];
    var profileParameter = {
        type: "other",
        expertUuid: expertUuid,
        matchUuid: matchUuid
    };
    var getOverlappingStrings = function(str1, str2) {
        var arr1 = str1.split(",").map(function(s) {
            return s.trim();
        }).filter(function(s) {
            return s !== "";
        });
        var arr2 = str2.split(",").map(function(s) {
            return s.trim();
        }).filter(function(s) {
            return s !== "";
        });
        return arr1.filter(function(value) {
            return arr2.includes(value);
        });
    };
    var matchedSkills = (0,react.useMemo)(function() {
        if (!expertInfo) return [];
        var expertSkills = (expertInfo === null || expertInfo === void 0 ? void 0 : expertInfo.industry) + "," + (expertInfo === null || expertInfo === void 0 ? void 0 : expertInfo.skill);
        var neededSkills = (expertInfo === null || expertInfo === void 0 ? void 0 : expertInfo.matchNeededSkills) || "";
        return getOverlappingStrings(expertSkills, neededSkills);
    }, [
        expertInfo
    ]);
    var ref1 = (0,es.useQuery)(profileQueryParameter, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        withLoader((0,profile/* getProfileData */.$y)(profileParameter), "로딩 중입니다\n1~3초 정도 소요됩니다")
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }), {
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        retryOnMount: false,
        staleTime: Infinity,
        cacheTime: Infinity,
        onError: function(error) {
            setSnackbareState("전문가 데이터가 존재하지 않습니다.\n이전 전문가라면 해당 아이디로 가입하셨는지 확인해주세요.");
            router.replace("/expert-application");
        }
    }), isLoading = ref1.isLoading, isError = ref1.isError, data = ref1.data;
    (0,react.useEffect)(function() {
        if (data) {
            setExpertInfo(data.data);
        }
    }, [
        data
    ]);
    if (isLoading || isError) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(OtherProfile_Wrapper, {
        children: expertInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    className: "profile-inner-content",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Section1, {
                            data: expertInfo,
                            showOpenPrice: !!direct || !!direct2,
                            isRecommended: isRecommended,
                            aiSummarySlot: aiSummarySlot
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SignComponent/* EmptySpace */.zV, {
                            space: 40
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Section2, {
                            data: expertInfo,
                            matchUuid: matchUuid,
                            matchedSkills: matchedSkills,
                            matchedExpertDataUuid: matchedExpertDataUuid,
                            isNoShowButton: isNoShowButton,
                            noShowPortfolio: !!direct || !!direct2
                        }),
                        direct ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "100%",
                                    position: "fixed",
                                    bottom: "100px",
                                    left: "50%",
                                    transform: "translateX(-50%)"
                                },
                                id: "accept-button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                                    order: "row-center-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* ButtonA */.bx, {
                                        fullWidth: true,
                                        sx: {
                                            width: "500px",
                                            maxWidth: "90%"
                                        },
                                        buttonClass: "primary",
                                        size: "large",
                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                window.open("https://tally.so/r/mVvQ9g?eid=".concat(expertUuid));
                                                return [
                                                    2
                                                ];
                                            });
                                        }),
                                        children: "업무 제안하기"
                                    })
                                })
                            })
                        }) : null,
                        direct2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "100%",
                                    position: "fixed",
                                    bottom: "100px",
                                    left: "50%",
                                    transform: "translateX(-50%)"
                                },
                                id: "accept-button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* GroupA */.so, {
                                    order: "row-center-center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ruix/* ButtonA */.bx, {
                                        fullWidth: true,
                                        sx: {
                                            width: "500px",
                                            maxWidth: "90%"
                                        },
                                        buttonClass: "primary",
                                        size: "large",
                                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                            return (0,tslib_es6.__generator)(this, function(_state) {
                                                window.open("https://tally.so/r/woKeKe?eid=".concat(expertUuid));
                                                return [
                                                    2
                                                ];
                                            });
                                        }),
                                        children: "업무 제안하기"
                                    })
                                })
                            })
                        }) : null
                    ]
                }),
                matchUuid && /*#__PURE__*/ (0,jsx_runtime.jsx)(Section3, {})
            ]
        })
    });
};
var OtherProfile_Wrapper = emotion_styled_browser_esm/* default.div */.Z.div(OtherProfile_templateObject());
var Content = emotion_styled_browser_esm/* default.div */.Z.div(OtherProfile_templateObject1());


/***/ }),

/***/ 22240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77366);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61225);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21448);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	display: flex;\n	flex-direction: row;\n	justify-content: start;\n	align-items: center;\n	font-size: 14px;\n	margin-bottom: 12px;\n\n	.header {\n		padding: 8px 0;\n		flex-grow: 0;\n		flex-shrink: 0;\n		color: var(--card-bg);\n		font-size: 14px;\n		font-style: normal;\n		font-weight: 600;\n		line-height: normal;\n		white-space: pre-line;\n		word-break: keep-all;\n		width: 120px;\n		flex-basis: 120px;\n\n		@media screen and (max-width: 900px) {\n			font-size: 13px;\n			width: 100px;\n			flex-basis: 100px;\n		}\n	}\n\n	.contents {\n		padding: 8px 14px;\n		flex: 1;\n		flex-shrink: 1;\n		white-space: pre-wrap;\n		word-break: break-all;\n		font-size: 14px;\n		font-style: normal;\n		font-weight: 400;\n		color: var(--card-bg);\n		flex-wrap: wrap;\n		display: flex;\n		flex-direction: column;\n		border: 1px solid #E4E4E7;\n		border-radius: 8px;\n		background-color: var(--bg-white);\n		min-height: 20px;\n\n		@media screen and (max-width: 900px) {\n			font-size: 13px;\n			padding: 8px 12px;\n		}\n	}\n\n	.chip * {\n		@media screen and (max-width: 900px) {\n			font-size: 13px;\n		}\n	}\n\n	.contents > div {\n		color: var(--card-bg);\n		margin-right: 5px;\n		margin-top: 4px;\n		margin-bottom: 4px;\n	}\n\n	.link {\n		color: -webkit-link;\n		cursor: pointer;\n		text-decoration: underline;\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ProfileListItem = function(props) {
    var text = props.text, title = props.title, notChip = props.notChip, link = props.link, invisibleOption = props.invisibleOption, topAlign = props.topAlign;
    var isMobile = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("(max-width: 768px)");
    if (invisibleOption && !text) return null;
    var getContent = function() {
        if (link) {
            var href = text && !text.startsWith("http://") && !text.startsWith("https://") ? "https://".concat(text) : text;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    className: "link",
                    style: {
                        color: "var(--card-bg)"
                    },
                    target: "_blank",
                    href: href,
                    rel: "noreferrer",
                    children: text
                })
            });
        }
        // notChip이 true이고 내부 협업 가능 인력이 아닌 경우 불릿 포인트 처리
        if (notChip && title !== "내부 협업 가능 인력") {
            var processedText = text === null || text === void 0 ? void 0 : text.split("\n").map(function(line, index) {
                if (line.trim().startsWith("-")) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        style: {
                            display: "flex",
                            alignItems: "flex-start",
                            marginBottom: "8px",
                            lineHeight: "1.5"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                style: {
                                    marginRight: "8px",
                                    marginTop: "1px",
                                    color: "#666",
                                    fontSize: "14px",
                                    fontWeight: "bold"
                                },
                                children: "•"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                style: {
                                    flex: 1
                                },
                                children: line.trim().substring(1).trim()
                            })
                        ]
                    }, index);
                }
                return line ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    style: {
                        marginBottom: "8px",
                        lineHeight: "1.5"
                    },
                    children: line
                }, index) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("br", {}, index);
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                    width: "100%"
                },
                children: processedText
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
            children: !notChip ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                style: {
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "6px"
                },
                children: text && text.split(",").map(function(t, i) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        sx: {
                            color: "var(--primary-darken)",
                            backgroundColor: "#f0f4ff",
                            borderRadius: "6px",
                            border: "none",
                            fontSize: "13px",
                            fontWeight: 500,
                            height: "auto",
                            "& .MuiChip-label": {
                                padding: "5px 10px"
                            }
                        },
                        className: "chip",
                        label: t
                    }, i);
                })
            }) : text
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(ListItemContainer, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "header",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "contents",
                children: getContent()
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ProfileListItem);
var ListItemContainer = _emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"].li */ .Z.li(_templateObject());


/***/ }),

/***/ 81812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$5": function() { return /* binding */ numberWithCommasFromString; },
/* harmony export */   "R1": function() { return /* binding */ doCopy; },
/* harmony export */   "tw": function() { return /* binding */ numberWithCommasFromNumber; }
/* harmony export */ });
/* unused harmony exports cutZero, downloadFile, makeNumber, timeMake */
var doCopy = function(text) {
    return new Promise(function(resolve, reject) {
        try {
            // 흐름 1.
            if (navigator.clipboard) {
                // (IE는 사용 못하고, 크롬은 66버전 이상일때 사용 가능합니다.)
                navigator.clipboard.writeText(text).then(function() {
                    resolve("클립보드에 복사되었습니다.");
                }).catch(function() {
                    resolve("복사를 다시 시도해주세요.");
                });
            } else {
                // 흐름 2.
                if (!document.queryCommandSupported("copy")) {
                    return resolve("복사하기가 지원되지 않는 브라우저입니다.");
                }
                // 흐름 3.
                var textarea = document.createElement("textarea");
                textarea.value = text;
                textarea.style.top = "0";
                textarea.style.left = "0";
                textarea.style.position = "fixed";
                // 흐름 4.
                document.body.appendChild(textarea);
                // focus() -> 사파리 브라우저 서포팅
                textarea.focus();
                // select() -> 사용자가 입력한 내용을 영역을 설정할 때 필요
                textarea.select();
                // 흐름 5.
                document.execCommand("copy");
                // 흐름 6.
                document.body.removeChild(textarea);
                resolve("클립보드에 복사되었습니다.");
            }
        } catch (error) {
            resolve("복사하기가 지원되지 않는 브라우저입니다.");
        }
    });
};
function numberWithCommasFromString(x) {
    if (!x) return 0;
    return makeNumber(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
function numberWithCommasFromNumber(x) {
    if (!x) return 0;
    return Math.round(x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
var cutZero = function(str) {
    if (str[str.length - 1] === "0") {
        return Number(str.slice(0, -1));
    } else return str;
};
function timeMake(num) {
    return cutZero((Math.round((num || 0) * 10) / 10).toFixed(2));
}
var makeNumber = function(numStr) {
    var count = Number(numStr.split(",").join(""));
    return Number(count.toFixed(0));
};
function downloadFile(imageURL, fileName) {
    var img = new Image();
    img.crossOrigin = "Anonymous";
    img.id = "getshot";
    img.src = imageURL;
    document.body.appendChild(img);
    var getshot = document.getElementById("getshot");
    var a = document.createElement("a");
    a.href = getshot.src;
    // a.target = "_blank";
    a.click();
    document.body.removeChild(img);
}



/***/ })

}]);